module.exports = __webpack_public_path__ + "static/media/water.8aecb203.jpg";